import { i18n } from './i18n';
import { formatDate } from './date';

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Texto de una alerta de revisión del servicio: «Fecha prevista de baja en X días (dd/mm/aaaa)».
 *
 * La `reference` del evento es la fecha prevista de baja en ISO (yyyy-MM-dd). Los días se cuentan contra HOY,
 * no contra el momento del aviso: lo que necesita el operador es cuánto margen queda ahora. Se comparan días
 * naturales a medianoche local, así que un cambio de horario no descuadra la cuenta.
 *
 * Si la reference no es una fecha, se devuelve tal cual antes que romper la card.
 */
export const serviceReviewLabel = (reference?: string | null, now: Date = new Date()): string | null => {
  if (!reference) return null;
  const endDate = new Date(`${reference}T00:00:00`);
  if (isNaN(endDate.getTime())) return reference;

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const days = Math.round((endDate.getTime() - today.getTime()) / DAY_MS);
  const date = formatDate(endDate.getTime());

  if (days === 0) return i18n('alarm.queue.serviceReview.today').replace('{date}', date);
  if (days < 0) {
    return i18n('alarm.queue.serviceReview.overdue').replace('{days}', String(-days)).replace('{date}', date);
  }
  const key = days === 1 ? 'alarm.queue.serviceReview.inOneDay' : 'alarm.queue.serviceReview.inDays';
  return i18n(key).replace('{days}', String(days)).replace('{date}', date);
};
